"use strict";

var _objectSpread = require("/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveOrCreateATA = resolveOrCreateATA;
exports.resolveOrCreateATAs = resolveOrCreateATAs;
const spl_token_1 = require("@solana/spl-token");
const math_1 = require("../math");
const network_1 = require("./network");
const token_util_1 = require("./token-util");
const types_1 = require("./transactions/types");
async function resolveOrCreateATA(connection, ownerAddress, tokenMint, getAccountRentExempt) {
  let wrappedSolAmountIn = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : math_1.ZERO;
  let payer = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ownerAddress;
  let modeIdempotent = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  let allowPDAOwnerAddress = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  let wrappedSolAccountCreateMethod = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : "keypair";
  const instructions = await resolveOrCreateATAs(connection, ownerAddress, [{
    tokenMint,
    wrappedSolAmountIn
  }], getAccountRentExempt, payer, modeIdempotent, allowPDAOwnerAddress, wrappedSolAccountCreateMethod);
  return instructions[0];
}
async function resolveOrCreateATAs(connection, ownerAddress, requests, getAccountRentExempt) {
  let payer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : ownerAddress;
  let modeIdempotent = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  let allowPDAOwnerAddress = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  let wrappedSolAccountCreateMethod = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "keypair";
  const nonNativeMints = requests.filter(_ref => {
    let {
      tokenMint
    } = _ref;
    return !tokenMint.equals(spl_token_1.NATIVE_MINT);
  });
  const nativeMints = requests.filter(_ref2 => {
    let {
      tokenMint
    } = _ref2;
    return tokenMint.equals(spl_token_1.NATIVE_MINT);
  });
  const nativeMint2022 = requests.filter(_ref3 => {
    let {
      tokenMint
    } = _ref3;
    return tokenMint.equals(spl_token_1.NATIVE_MINT_2022);
  });
  if (nativeMints.length > 1) {
    throw new Error("Cannot resolve multiple WSolAccounts");
  }
  if (nativeMint2022.length > 0) {
    throw new Error("NATIVE_MINT_2022 is not supported");
  }
  let instructionMap = {};
  if (nonNativeMints.length > 0) {
    const mints = await (0, network_1.getMultipleParsedAccounts)(connection, nonNativeMints.map(a => a.tokenMint), network_1.ParsableMintInfo);
    const nonNativeAddresses = nonNativeMints.map((_ref4, index) => {
      let {
        tokenMint
      } = _ref4;
      return (0, spl_token_1.getAssociatedTokenAddressSync)(tokenMint, ownerAddress, allowPDAOwnerAddress, mints[index].tokenProgram);
    });
    const tokenAccounts = await (0, network_1.getMultipleParsedAccounts)(connection, nonNativeAddresses, network_1.ParsableTokenAccountInfo);
    tokenAccounts.forEach((tokenAccount, index) => {
      const ataAddress = nonNativeAddresses[index];
      let resolvedInstruction;
      if (tokenAccount) {
        if (!tokenAccount.owner.equals(ownerAddress)) {
          throw new Error("ATA with change of ownership detected: ".concat(ataAddress.toBase58()));
        }
        resolvedInstruction = _objectSpread({
          address: ataAddress,
          tokenProgram: tokenAccount.tokenProgram
        }, types_1.EMPTY_INSTRUCTION);
      } else {
        const createAtaInstruction = modeIdempotent ? (0, spl_token_1.createAssociatedTokenAccountIdempotentInstruction)(payer, ataAddress, ownerAddress, nonNativeMints[index].tokenMint, mints[index].tokenProgram) : (0, spl_token_1.createAssociatedTokenAccountInstruction)(payer, ataAddress, ownerAddress, nonNativeMints[index].tokenMint, mints[index].tokenProgram);
        resolvedInstruction = {
          address: ataAddress,
          tokenProgram: mints[index].tokenProgram,
          instructions: [createAtaInstruction],
          cleanupInstructions: [],
          signers: []
        };
      }
      instructionMap[nonNativeMints[index].tokenMint.toBase58()] = resolvedInstruction;
    });
  }
  if (nativeMints.length > 0) {
    var _nativeMints$;
    const accountRentExempt = await getAccountRentExempt();
    const wrappedSolAmountIn = ((_nativeMints$ = nativeMints[0]) === null || _nativeMints$ === void 0 ? void 0 : _nativeMints$.wrappedSolAmountIn) || math_1.ZERO;
    instructionMap[spl_token_1.NATIVE_MINT.toBase58()] = token_util_1.TokenUtil.createWrappedNativeAccountInstruction(ownerAddress, wrappedSolAmountIn, accountRentExempt, payer, undefined, wrappedSolAccountCreateMethod);
  }
  return requests.map(_ref5 => {
    let {
      tokenMint
    } = _ref5;
    return instructionMap[tokenMint.toBase58()];
  });
}
//# sourceMappingURL=ata-util.js.map